var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page page--container"},[_c('PageContent',[_c('h2',[_vm._v("My Saved Favorites")]),_c('FavoritesList')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }